module.exports = __webpack_public_path__ + "static/media/android-original.fb9e143a.svg";